export const IMAGE_WIDTH = {
  DESKTOP: 480,
  TABLET_BIG: 594,
};

export const NAV_STATES = {
  IMAGE_ZOOM_INIT: 'IMAGE_ZOOM_INIT',
  IMAGE_ZOOMED: 'IMAGE_ZOOMED',
};

export const SEO_IMAGE_ATTRIBUTES = {
  IMAGE_ALT_PREFIX: '',
  IMAGE_ALT_SUFFIX: 'Online Shopping',
  IMAGE_TITLE_PREFIX: 'Buy',
  IMAGE_TITLE_SUFFIX: 'Online',
};

export const PLACEHOLDER_IMAGE_WIDTH = 198;
